package com.gsb.vyapar.bhagya.presentation.search.util

import com.gsb.vyapar.bhagya.domain.Categories.D.Category
import com.gsb.vyapar.bhagya.domain.getName
import com.gsb.vyapar.bhagya.domain.getPincode
import com.gsb.vyapar.bhagya.domain.getRegistrationNumber
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.business.util.sortedByDistance
import com.gsb.vyapar.bhagya.presentation.search.uistate.getSearchUiState
import kotlinx.coroutines.delay

fun queryString(search: String) {
    val searchCategories = if (search.isEmpty()) listOf() else {
        getState().getCategories().getCategoriesList().filter {
            it.name.contains(search, true)
        }.take(5)
    }
    val searchSubCategories = if (search.isEmpty()) listOf() else {
        getState().getSubCategories().d.subCategories.filter {
            it.name.contains(search, true)
        }.take(5)
    }
    val searchBusinessList = if (search.isEmpty()) listOf() else {
        getBusinessUiState().businessList.filter {
            it.getName().contains(search, true) ||
            it.getRegistrationNumber().contains(search, true) ||
            it.getPincode().contains(search, true)
        }.sortedByDistance()
    }
    getSearchUiState().updateAllSearchUiState(search, searchCategories, searchSubCategories, searchBusinessList)
}

fun updateFilteredBusinessList(selectedCategory: Category?, subCategory: String) {
    launchDefault {
        delay(100)
        getBusinessUiState().updateFilteredBusinessList(selectedCategory, subCategory)
    }
}